export default "__VITE_ASSET__BM4GXsJC__"